import { FETCH_INSTRUCTION_CATS } from '../actionTypes';

const initialState = null;

export default function(state = initialState, action=null){
  if (action.type === FETCH_INSTRUCTION_CATS) {
    return {...action.payload};
  } else {
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/instructionCats.js